import IdpApprovalList from './model';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'studentIDPId':
      return [key, `${val}`];  // stringify
    default:
      return [key, val];
  }
};

const create = (data) => new IdpApprovalList(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/IdpApprovalList/create.js